import { Button, Col, Form, Row, Space, Switch } from "antd";
import { CardTable } from "components/card-table";
import { Spinal } from "components/spinal/Spinal";
import { useUserState } from "pages/beheer/machtiging/use-user-state";
import { PercelenModel } from "pages/bodem-en-gewas/percelen-old/models/percelenMock";
import { FC } from "react";
import { GewasRow } from "./gewasRow";

interface GewasTypeProps {
  type: {
    title: string;
    formKey: string;
  };
  isKlwReadOnly: boolean;
  isLoading: boolean;
}
export const GewasType: FC<GewasTypeProps> = ({
  type,
  isKlwReadOnly,
  isLoading,
}) => {
  const state = useUserState();
  const isAkkerbouw = type.title === "Akkerbouw";
  const isGrass = type.title === "Productiegrasland";
  return (
    <>
      <CardTable.SubHeader infoContent={<></>}>
        <CardTable.SubHeader.ColumnTitles>
          <Row gutter={12}>
            <Col span={24}>
              <h3>{type.title}</h3>
            </Col>
            <Col span={5} style={{ paddingLeft: 16 }} className="text-left">
              Teelttype
            </Col>
            <Col span={3} style={{ paddingLeft: 16 }} className="text-left">
              Gewastype
            </Col>
            {!isAkkerbouw && (
              <Col span={7} style={{ paddingLeft: 16 }} className="text-left">
                Gewasgroepen
              </Col>
            )}
            <Col span={2} className="text-right">
              Oppervlakte
              <CardTable.ColumnUnit>[ha]</CardTable.ColumnUnit>
            </Col>
            <Form.Item
              noStyle
              shouldUpdate={(prev, cur) => {
                return (
                  prev.voorNaTeeltVanggewassen?.[type.formKey][0]
                    ?.isOpgegeven !==
                  cur.voorNaTeeltVanggewassen?.[type.formKey][0]?.isOpgegeven
                );
              }}
            >
              {({ getFieldValue }) => {
                const isOpgegeven: boolean = getFieldValue([
                  "voorNaTeeltVanggewassen",
                  type.formKey,
                  0,
                  "isOpgegeven",
                ]);
                return (
                  isOpgegeven && (
                    <>
                      <Col span={1} className="text-right">
                        Opbrengst
                        <CardTable.ColumnUnit>[kg ds/ha]</CardTable.ColumnUnit>
                      </Col>
                      <Col span={2} className="text-right">
                        Stikstof
                        <CardTable.ColumnUnit>[g/kg ds]</CardTable.ColumnUnit>
                      </Col>
                      <Col span={1} className="text-right">
                        Fosfor
                        <CardTable.ColumnUnit>[g/kg ds]</CardTable.ColumnUnit>
                      </Col>
                      <Col span={2} className="text-right">
                        VEM
                        <CardTable.ColumnUnit>[VEM/kg ds]</CardTable.ColumnUnit>
                      </Col>
                    </>
                  )
                );
              }}
            </Form.Item>
          </Row>
        </CardTable.SubHeader.ColumnTitles>
      </CardTable.SubHeader>
      <CardTable.Body>
        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) => {
            return (
              prev.gewasgroepen !== cur.gewasgroepen ||
              prev.voorNaTeeltVanggewassen !== cur.voorNaTeeltVanggewassen ||
              prev.bouwlandenTeeltTypesGrondgebruikTypes !==
                cur.bouwlandenTeeltTypesGrondgebruikTypes
            );
          }}
        >
          {({ getFieldValue }) => {
            const gewasgroepen: PercelenModel["gewasgroepen"] = getFieldValue([
              "gewasgroepen",
            ]);
            const voorNaTeeltVanggewassen: PercelenModel["voorNaTeeltVanggewassen"] =
              getFieldValue(["voorNaTeeltVanggewassen"]);
            const bouwlandenTeeltTypesGrondgebruikTypes: PercelenModel["bouwlandenTeeltTypesGrondgebruikTypes"] =
              getFieldValue(["bouwlandenTeeltTypesGrondgebruikTypes"]);
            return (
              <Spinal
                initializing={
                  !gewasgroepen ||
                  !voorNaTeeltVanggewassen ||
                  !bouwlandenTeeltTypesGrondgebruikTypes
                }
                loading={isLoading}
              >
                <Form.List
                  name={["voorNaTeeltVanggewassen", `${type.formKey}`]}
                >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map((field, index) => (
                        <>
                          <GewasRow
                            index={index}
                            isKlwReadOnly={isKlwReadOnly}
                            type={type}
                            remove={remove}
                          />
                        </>
                      ))}
                      <Space>
                        <Button
                          disabled={isKlwReadOnly}
                          onClick={() => add({})}
                          size="small"
                          type="primary"
                          shape="round"
                        >
                          Gewas toevoegen
                        </Button>
                        {(parseFloat(
                          state?.userState?.kringloopwijzerJaar || "0"
                        ) >= 2022 ||
                          isGrass) && (
                          <Form.Item
                            name={[0, "isOpgegeven"]}
                            valuePropName="checked"
                          >
                            <Switch
                              disabled={isKlwReadOnly}
                              checkedChildren="opgeven"
                              unCheckedChildren="normatief"
                            />
                          </Form.Item>
                        )}
                      </Space>
                    </>
                  )}
                </Form.List>
              </Spinal>
            );
          }}
        </Form.Item>
      </CardTable.Body>
    </>
  );
};
